import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";

import ExpenseItemsTab from "./tabs/ExpenseItemsTab";
import ExpenseAdvancesTab from "./tabs/ExpenseAdvancesTab";
import ExpenseSignaturesTab from "./tabs/ExpenseSignaturesTab";
import ExpensePaymentsTab from "./tabs/ExpensePaymentsTab";

const ExpenseDocumentTabs = ({
  documentId,
  status,
  isLocked,
  onRefreshSummary,
}) => {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Tabs value={tab} onChange={(e, v) => setTab(v)}>
        <Tab label="Gastos" />
        <Tab label="Anticipos" />
        <Tab label="Pagos" />
        <Tab label="Firmas" />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {tab === 0 && (
          <ExpenseItemsTab
            documentId={documentId}
            isLocked={isLocked}
            onRefreshSummary={onRefreshSummary}
          />
        )}
        {tab === 1 && (
          <ExpenseAdvancesTab
            documentId={documentId}
            isLocked={isLocked}
            onRefreshSummary={onRefreshSummary}
          />
        )}
        {tab === 2 && (
          <ExpensePaymentsTab
            documentId={documentId}
            status={status}
            onPaid={() => window.location.reload()}
          />
        )}
        {tab === 3 && (
          <ExpenseSignaturesTab
            documentId={documentId}
            status={status}
            onSigned={() => window.location.reload()}
          />
        )}
      </Box>
    </Box>
  );
};

export default ExpenseDocumentTabs;
